
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-9'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - 배너 관리
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              수정
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageInfo pointTextBlue">
            <p>메인 매거진 영역</p>
          </div>
          <div class="Admin_imgBanner_BoxWrap mgb40">
            <div class="Admin_imgBanner_BoxTit">배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이벤트 배너 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1300 x 870px</p>
                <label for='banner_event_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_event_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'event')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerEventImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerEventImageURL"
                    alt="이벤트 배너 이미지"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='banner_props_link'>소품 배너 링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'banner_props_link'
                maxLength="300"
                placeholder = "소품 배너 클릭 시 이동할 링크 주소를 작성해 주세요."
                v-model="formData.bannerPropsLink"
              />
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap mgb40">
            <div class="Admin_imgBanner_BoxTit">배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>소품 배너 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1300 x 770px</p>
                <label for='banner_props_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_props_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'props')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerPropsImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerPropsImageURL"
                    alt="소품 배너 이미지"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='banner_notice_link'>공지사항 배너 링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'banner_notice_link'
                maxLength="300"
                placeholder = "공지사항 배너 클릭 시 이동할 링크 주소를 작성해 주세요."
                v-model="formData.bannerNoticeLink"
              />
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap mgb40">
            <div class="Admin_imgBanner_BoxTit">배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>공지사항 배너 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1300 x 770px</p>
                <label for='banner_notice_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_notice_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'notice')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerNoticeImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerNoticeImageURL"
                    alt="공지사항 배너 이미지"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap mgb40">
            <div class="Admin_imgBanner_BoxTit">배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>Best 배너 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1300 x 380px</p>
                <label for='banner_best_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_best_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'best')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerBestImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerBestImageURL"
                    alt="베스트 배너 이미지"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="Admin_PageInfo pointTextBlue">
            <p>NFU PICK 영역</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="nfu_pick_background">NFU PICK 배경<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type="color"
                id="nfu_pick_background"
                v-model="formData.bannerNfuPickBackground"
              />
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="banner_nfu_pick_title">NFU PICK 타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id="banner_nfu_pick_title"
                maxLength="300"
                placeholder = "NFU PICK 타이틀을 작성해 주세요."
                v-model="formData.bannerNfuPickTitle"
              />
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="banner_nfu_pick_sub_title">NFU PICK 서브 설명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id="banner_nfu_pick_sub_title"
                maxLength="300"
                placeholder = "NFU PICK 서브 설명을 작성해 주세요."
                v-model="formData.bannerNfuPickSubTitle"
              />
            </div>
          </div>
          <div class="Admin_imgBanner_BoxWrap mgb40">
            <div class="Admin_imgBanner_BoxTit">배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>NFU PICK 설명 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 900 x 500px</p>
                <label for='banner_nfu_pick_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_nfu_pick_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'nfu_pick')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerNfuPickImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerNfuPickImageURL"
                    alt="NFU PICK 설명 이미지"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="Admin_PageInfo pointTextBlue">
            <p>가로 배너 영역</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='banner_width_link'>가로 배너 링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'banner_width_link'
                maxLength="300"
                placeholder = "가로 배너 클릭 시 이동할 링크 주소를 작성해 주세요."
                v-model="formData.bannerWidthLink"
              />
            </div>
          </div>
          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>가로 배너 PC 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1920 x 160px</p>
                <label for='banner_width_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_width_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'width')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerWidthImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerWidthImageURL"
                    alt="가로 배너 이미지"
                  />
                </p>
              </div>
            </div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>가로 배너 모바일 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1100 x 330px</p>
                <label for='banner_width_mobile_image' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'banner_width_mobile_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="(event) => changeImage(event, 'width_mobile')"
                  />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.bannerWidthMobileImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.bannerWidthMobileImageURL"
                    alt="가로 배너 이미지"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_banner,
  update_banner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminBannerManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner
  },
  setup () {
    return {
      formData: ref({
        bannerEventImage: '',
        bannerEventImageURL: '',
        bannerPropsImage: '',
        bannerPropsImageURL: '',
        bannerPropsLink: '',
        bannerNoticeImage: '',
        bannerNoticeImageURL: '',
        bannerNoticeLink: '',
        bannerBestImage: '',
        bannerBestImageURL: '',
        bannerNfuPickBackground: '#ffffff',
        bannerNfuPickImage: '',
        bannerNfuPickImageURL: '',
        bannerNfuPickTitle: '',
        bannerNfuPickSubTitle: '',
        bannerWidthImage: '',
        bannerWidthImageURL: '',
        bannerWidthMobileImage: '',
        bannerWidthMobileImageURL: '',
        bannerWidthLink: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data, target) {
      if (event_data.target.files[0] !== undefined) {
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          if (target === 'event') {
            this.formData.bannerEventImage = event_data.target.files[0]
            this.formData.bannerEventImageURL = reader.result
          } else if (target === 'props') {
            this.formData.bannerPropsImage = event_data.target.files[0]
            this.formData.bannerPropsImageURL = reader.result
          } else if (target === 'notice') {
            this.formData.bannerNoticeImage = event_data.target.files[0]
            this.formData.bannerNoticeImageURL = reader.result
          } else if (target === 'best') {
            this.formData.bannerBestImage = event_data.target.files[0]
            this.formData.bannerBestImageURL = reader.result
          } else if (target === 'nfu_pick') {
            this.formData.bannerNfuPickImage = event_data.target.files[0]
            this.formData.bannerNfuPickImageURL = reader.result
          } else if (target === 'width') {
            this.formData.bannerWidthImage = event_data.target.files[0]
            this.formData.bannerWidthImageURL = reader.result
          } else if (target === 'width_mobile') {
            this.formData.bannerWidthMobileImage = event_data.target.files[0]
            this.formData.bannerWidthMobileImageURL = reader.result
          }
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (continue_add) {
        this.statusData.spinnerStatus = true
        update_banner(
          this.formData.bannerEventImage,
          this.formData.bannerPropsImage,
          this.formData.bannerPropsLink,
          this.formData.bannerNoticeImage,
          this.formData.bannerNoticeLink,
          this.formData.bannerBestImage,
          this.formData.bannerNfuPickBackground,
          this.formData.bannerNfuPickImage,
          this.formData.bannerNfuPickTitle,
          this.formData.bannerNfuPickSubTitle,
          this.formData.bannerWidthImage,
          this.formData.bannerWidthMobileImage,
          this.formData.bannerWidthLink
        ).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
        })
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    get_banner().then((result) => {
      this.formData.bannerEventImageURL = result[0].banner_event_image
      this.formData.bannerPropsImageURL = result[0].banner_props_image
      this.formData.bannerPropsLink = result[0].banner_props_link
      this.formData.bannerNoticeImageURL = result[0].banner_notice_image
      this.formData.bannerNoticeLink = result[0].banner_notice_link
      this.formData.bannerBestImageURL = result[0].banner_best_image
      this.formData.bannerNfuPickBackground = result[0].banner_nfu_pick_background
      this.formData.bannerNfuPickImageURL = result[0].banner_nfu_pick_image
      this.formData.bannerNfuPickTitle = result[0].banner_nfu_pick_title
      this.formData.bannerNfuPickSubTitle = result[0].banner_nfu_pick_sub_title
      this.formData.bannerWidthImageURL = result[0].banner_width_image
      this.formData.bannerWidthMobileImageURL = result[0].banner_width_mobile_image
      this.formData.bannerWidthLink = result[0].banner_width_link
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminBannerManagement.vue